import dayjs from "dayjs";
import * as yup from "yup";
import {
  lessOrEqualOneYearMessage,
  requiredMessage,
} from "../shared/form/formValidatonRules";

const oneOfDatesRequired =
  "Either 'Updated Date' or 'Expiry Date' must be provided";

const isEmptyRange = (range) => {
  return (
    Array.isArray(range) &&
    (range[0] === null || range[0] === "") &&
    (range[1] === null || range[1] === "")
  );
};

export const manageRemindersSchema = yup.object().shape({
  AgencyKeys: yup.array().required(requiredMessage).min(1, requiredMessage),
  ReminderProfileIds: yup
    .array()
    .required(requiredMessage)
    .min(1, requiredMessage),
  UpdatedDate: yup
    .array()
    .of(yup.mixed().nullable())
    .test("at-least-one-range-filled", oneOfDatesRequired, function (value) {
      const { ExpiryDate } = this.parent;
      return !isEmptyRange(value) || !isEmptyRange(ExpiryDate);
    }),
  ExpiryDate: yup
    .array()
    .of(yup.mixed().nullable())
    .test(
      "lessThanYear",
      lessOrEqualOneYearMessage,
      (value) => dayjs(value[1]).diff(dayjs(value[0]), "year") === 0
    )
    .test("at-least-one-range-filled", oneOfDatesRequired, function (value) {
      const { UpdatedDate } = this.parent;
      return !isEmptyRange(value) || !isEmptyRange(UpdatedDate);
    }),
  ShowAutoplanPolicies: yup.boolean().required(requiredMessage),
  ShowSpecialPolicies: yup.boolean().required(requiredMessage),
  PolicyStatusActive: yup.boolean().required(requiredMessage),
  PolicyStatusExpired: yup.boolean().required(requiredMessage),
  PolicyStatusCancelled: yup.boolean().required(requiredMessage),
  PolicyStatusRenewed: yup.boolean().required(requiredMessage),
  PolicyStatusLost: yup.boolean().required(requiredMessage),
  PolicyStatus: yup
    .boolean()
    .when(
      [
        "PolicyStatusActive",
        "PolicyStatusExpired",
        "PolicyStatusCancelled",
        "PolicyStatusRenewed",
        "PolicyStatusLost",
      ],
      {
        is: false,
        then: yup
          .boolean()
          .required("At least one of the options is required."),
      }
    ),
  Show: yup.boolean().when(["ShowAutoplanPolicies", "ShowSpecialPolicies"], {
    is: false,
    then: yup.boolean().required("At least one of the options is required."),
  }),
});

export const changeStatusSchema = yup.object().shape({
  Status: yup.number().required(requiredMessage),
  ProcessingStage: yup.number().required(requiredMessage),
  Notes: yup
    .string()
    .required(requiredMessage)
    .min(3, "Notes must be at least 3 characters")
    .max(120, "Notes cannot exceed 500 characters"),
});
